import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './App.css';
import Navbar from './components/Navbar/Navbar';

import { setAuth } from './store/auth/auth.slice';
import { AppDispatch, TRootState } from './store/store';
import { adminModeStatus, resetLogin, resetUser, setLoadingAmount, setOpenLocale } from './store/user/user.slice';
import { transport } from './utils/constants';
import { getToken, isRpcError, Notification, onImagesLoad, setAvas, type } from './utils/helper';

import { useTranslation } from 'react-i18next';
import { matchPath, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { mellIcon, usdtIcon } from './assets';
import ControlledInput from './components/Common/ControlledInput/ControlledInput';
import IosModal from './components/Common/IosModal/IosModal';
import Search from './components/Common/Search/Search';
import ShortProfile from './components/Common/ShortProfile/ShortProfile';
import SignUp from './components/Common/SignUp/SignUp';
import LoadingApp from './components/LoadingApp/LoadingApp';
import Locale from './components/Locale/Locale';
import Modal from './components/Modal/Modal';
import Naviagtion from './components/Title/Navigation/Naviagtion';

import { publicRoutes, removeNavFoot } from './routes';
import { setSchemes } from './store/scheme/schemes.slice';
import { resetBalance, setLoadingWallet } from './store/wallet/wallet.slice';
import { ThemeName } from './types/navBar';

import { setDistribution } from './store/distribution/distribution.slice';
import { Account_Info } from './generated/mlmbox/types/account';
import { TelegramBotSignRequest } from './generated/mlmbox/client/auth/auth';
import { AuthClient } from './generated/mlmbox/client/auth/auth.client';
import { Status_Auth } from './generated/mlmbox/types/status';
import { AppClient } from './generated/mlmbox/client/app/app.client';
import { Empty } from './generated/google/protobuf/empty';
import { AccountClient } from './generated/mlmbox/client/account/account.client';
import { WalletClient } from './generated/mlmbox/client/finance/wallet.client';
import { DistributionClient } from './generated/mlmbox/client/distribution/distribution.client';
import { initializeStorage } from './shared/utils/ls';

async function start() {
    // if (Number(window.Telegram.WebApp.version) <= 6) return;
    try {
        window.Telegram.WebApp.disableVerticalSwipes();
        window.Telegram.WebApp.lockOrientation();

        // if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        //     window.Telegram.WebApp.requestFullscreen();
        // }
    } catch (e) {}

    // document.body.classList.add('full-screen-body');
}

start();
const backButton = window.Telegram.WebApp.BackButton;
const App: React.FC = () => {
    const isAuth = useSelector((state: TRootState) => state.auth.value.isAuth);
    const userAcc = useSelector((state: TRootState) => state.user.value);

    const client = new AuthClient(transport);
    const shemes = new AppClient(transport);
    const account = new AccountClient(transport);
    const finance = new WalletClient(transport);
    const distributionClient = new DistributionClient(transport);

    const user = useSelector((state: TRootState) => state.user.value);
    const dispatch = useDispatch() as AppDispatch;
    const location = useLocation();
    const [finishLOading, setFinishLoading] = useState(false);
    const [addLogin, setAddLogin] = useState(false);
    const [loginValue, setLoginValue] = useState('');
    const [theme, setTheme] = useState<ThemeName | null>(null);
    const [regModal, setRegModal] = useState(false);
    const [addRef, setAddRef] = useState(false);
    const [selectRef, setSelectRef] = useState<Account_Info | null>();
    const openLocale = useSelector((state: TRootState) => state.user.value.openLocale);
    const { t } = useTranslation();
    const navigate = useNavigate();

    async function tg() {
        try {
            window.Telegram.WebApp.backgroundColor = ' #181a22';
            window.Telegram.WebApp.headerColor = ' #181a22';
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const root = document.getElementsByTagName('html')[0];
        if (!matchPath('/create/*', location.pathname) && !matchPath('/edit/*', location.pathname)) {
            root.classList.remove('ht');
        } else {
            root.classList.add('ht');
        }
    }, [location.pathname]);

    const errorLogin: { [key: string]: string } = {
        LOGIN_UNKNOWN: t('errors.login_unknown'),
        LOGIN_FORMAT_LEN_SHORT: t('errors.login_short'),
        LOGIN_FORMAT_LEN_LONG: t('errors.login_long'),
        LOGIN_FORMAT_UNSUPPORTED: t('errors.login_format'),
        LOGIN_FORMAT_IDENTIFICATION: t('errors.login_bad'),
        LOGIN_BUSY: t('errors.login_busy'),
    };

    useEffect(() => {
        tg();
        const storageTheme = window.localStorage.getItem('theme');

        if (!storageTheme) {
            if (window.matchMedia) {
                if (window.matchMedia('(prefers-color-scheme: light)').matches) {
                    setTheme(ThemeName.LIGHT);
                } else {
                    setTheme(ThemeName.DARK);
                }
            }
            return;
        }
        setTheme(storageTheme === ThemeName.DARK ? ThemeName.DARK : ThemeName.LIGHT);
    }, []);

    useEffect(() => {
        let isFullScreen = window?.Telegram.WebApp?.isFullscreen || false;
        if (isFullScreen) {
            document.body.classList.add(location.pathname !== '/contract' ? 'full-screen-page' : 'full-screen-body');
            document.body.style.setProperty(
                '--safe-area',
                `${
                    window?.Telegram?.WebApp?.contentSafeAreaInset?.top + window?.Telegram?.WebApp?.safeAreaInset?.top
                }px`
            );
        } else {
            document.body.classList.remove('full-screen-body');
            document.body.classList.remove('full-screen-page');
        }
        // document.body.style.setProperty('--safe-area', `${94}px`);
        // if (location.pathname === '/contract') {
        //     document.body.classList.add('full-screen-page');
        // } else {
        //     document.body.classList.add('full-screen-body');
        // }
    }, [window?.Telegram.WebApp?.isFullscreen, location.pathname]);

    useEffect(() => {
        if (!theme) return;
        const html = document.documentElement;
        html.id = theme;

        window.localStorage.setItem('theme', theme);
    }, [theme]);

    useEffect(() => {
        if (!matchPath('/contract/*', location.pathname)) {
            backButton.hide();
        } else {
            backButton.show();
        }

        backButton.onClick(() => {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');

            if (location.pathname === '/contract') navigate('/wallet?asset=1');
            if (location.pathname === '/contract/bonuses') navigate('/contract');
            if (location.pathname === '/contract/new') navigate('/contract');
        });
    }, [location.pathname]);

    const auth = () => {
        message.loading(t('auth.load'));

        const telegramBotSignRequest: TelegramBotSignRequest = {
            channelId: 1,
            initData: window?.Telegram?.WebApp?.initData,
            // initData:
            //     'query_id=AAEUZFAXAwAAABRkUBdR1ru8&user=%7B%22id%22%3A6833595412%2C%22first_name%22%3A%22Denis%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22ora9p%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FumNZEv1KYISBFZLjmIUw3f2BDmVfBKfr2IL1LQR0rA7fO8flOPA8-Un4kalKYTiw.svg%22%7D&auth_date=1738222663&signature=BnCanY3o3fYn6EC9SGDdNkNdZK3GBG4hOQOVWrI5ImVrbmtlo0O56XTB-IMnGxkQ3gzng7R-zPm0-z2h47-lCg&hash=864b265010b4816e9a320530da780aebdcf860f3274498991df4abc0b91fd13b',
        };
        client
            .telegramBotSign(telegramBotSignRequest, {})
            .then((response) => {
                const jwtToken = response.response.accessToken;

                dispatch(
                    setAuth({
                        isAuth: jwtToken,
                        authStatus: response.response.authStatus,
                        referralStatus: response.response.referralStatus,
                    })
                );
                if (response.response.authStatus === Status_Auth.SIGN_UP) {
                    dispatch(setOpenLocale(true));
                    setRegModal(true);
                }
                message.destroy();
            })
            .catch((err) => {
                if (isRpcError(err)) {
                    console.log(err.message);
                }
                message.destroy();
                // message.error(t('auth.error'));
                setTimeout(() => {
                    // window.Telegram.WebApp.close();
                }, 800);
            });
    };

    useEffect(() => {
        initializeStorage(user.info.account.id);
    }, [user]);

    useEffect(() => {
        window.Telegram.WebApp.expand();

        if (!isAuth) return;

        shemes.schemeInfo(Empty, { meta: { authorization: getToken() } }).then((data) => {
            dispatch(setSchemes(data.response));
            dispatch(setLoadingAmount({ loadingAmount: 1 }));
        });

        account.info(Empty, { meta: { authorization: getToken() } }).then(async (data) => {
            // if (typeof data.response.info?.profile?.telegram?.id === 'bigint') {
            //     data.response.info.profile.telegram.id = Number(data.response.info.profile.telegram.id);
            // }

            dispatch(resetUser(data.response));
            const info = data.response.info;
            if (info) {
                await setAvas([info]);
            }
            dispatch(setLoadingAmount({ loadingAmount: 2 }));
        });

        finance.info(Empty, { meta: { authorization: getToken() } }).then((data) => {
            dispatch(resetBalance(data.response.assets));
            dispatch(setLoadingWallet({ loading: false }));
            dispatch(setLoadingAmount({ loadingAmount: 3 }));
        });

        distributionClient.info(Empty, { meta: { authorization: getToken() } }).then((data) => {
            dispatch(setDistribution(data.response));
            dispatch(setLoadingAmount({ loadingAmount: 4 }));
        });
    }, [isAuth]);

    useEffect(() => {
        if (isAuth) return;
        auth();
    }, [isAuth]);

    function saveRef() {
        if (!selectRef?.account?.id) return;

        account
            .setReferral(
                { uniqueField: { accountId: selectRef?.account?.id, oneofKind: 'accountId' } },
                { authorization: getToken() }
            )
            .then(({ status }) => {
                if (status.code === 'OK') {
                    setAddRef(false);
                    message.success(t('ref.success'));
                }
            })
            .catch((err) => {
                if (isRpcError(err)) {
                    switch (err.message) {
                        case 'REFERRAL_UNKNOWN':
                            message.error(t('errors.ref_unknown'));
                            break;
                        case 'REFERRAL_WRONG_LINK':
                            message.error(t('errors.ref_wrong'));
                            break;
                        case 'REFERRAL_BUSY':
                            message.error(t('errors.ref_busy'));
                            break;
                        case 'REFERRAL_EXISTS':
                            message.error(t('errors.ref_exist'));

                            setAddRef(false);
                            break;
                        default:
                            break;
                    }
                }
            });
    }

    function saveLogin(value: string) {
        if (!value.length) return;

        account
            .setLogin({ login: value }, { meta: { authorization: getToken() } })
            .then(({ response, status }) => {
                if (status.code === 'OK') {
                    dispatch(resetLogin({ login: response.login }));
                    Notification(type.success);

                    message.success(t('login.msgs.success'));
                }
            })
            .catch((error) => {
                if (isRpcError(error)) {
                    Notification(type.error);
                    setAddLogin(false);
                    message.error(errorLogin[error.message]);
                }
            });
    }

    useEffect(() => {
        if (
            user.info.account.id &&
            !addRef &&
            !regModal &&
            !user.info.account.login &&
            userAcc.adminMode !== adminModeStatus.ON
        )
            setAddLogin(true);
    }, [user, addRef, regModal, userAcc.adminMode]);

    return (
        <>
            {' '}
            {theme && (
                <>
                    {!finishLOading && (
                        <LoadingApp
                            target={4}
                            close={() => setFinishLoading(true)}
                        />
                    )}
                    {isAuth && finishLOading && (
                        <>
                            {regModal && !user.openLocale && (
                                <Modal closeBtn={() => setRegModal(false)}>
                                    <SignUp
                                        closeFunc={() => setRegModal(false)}
                                        setAddRef={() => setAddRef(true)}
                                    />
                                </Modal>
                            )}
                            {addRef && (
                                <IosModal
                                    cancelBtnTitle={
                                        selectRef
                                            ? t('modals.ios.header.btns.back')
                                            : t('modals.ios.header.btns.cancel')
                                    }
                                    aproveBtnTitle={selectRef ? t('modals.ios.header.btns.confirm') : ''}
                                    title={t('modals.ios.header.titles.referral')}
                                    aprove={() => saveRef()}
                                    cancel={() => (selectRef ? setSelectRef(null) : setAddRef(false))}>
                                    <>
                                        {selectRef ? (
                                            <ShortProfile
                                                {...selectRef}
                                                dont={true}
                                            />
                                        ) : (
                                            <Search
                                                placeholder={t('placeholders.login_referral')}
                                                setSelect={setSelectRef}
                                            />
                                        )}
                                    </>
                                </IosModal>
                            )}
                            {openLocale && (
                                <Modal closeBtn={() => dispatch(setOpenLocale(false))}>
                                    <Locale />
                                </Modal>
                            )}
                            {addLogin && (
                                <ControlledInput
                                    title={t('modals.ios.header.titles.login')}
                                    close={() => setAddLogin(false)}
                                    typeInput="text"
                                    setValue={setLoginValue}
                                    value={loginValue}
                                    placeholder="your_login"
                                    fetch={saveLogin}>
                                    <ul className="login">
                                        <li>{t('login.settings.help_list.item_1')}</li>
                                        <li>{t('login.settings.help_list.item_2')}</li>
                                        <li>{t('login.settings.help_list.item_3')}</li>
                                    </ul>
                                </ControlledInput>
                            )}
                            {removeNavFoot() && (
                                <Navbar
                                    setTheme={setTheme}
                                    theme={theme}
                                />
                            )}
                            <div id="layout">
                                <Routes>
                                    {publicRoutes.map((route) => (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            Component={route.element}
                                        />
                                    ))}
                                </Routes>
                            </div>
                            {removeNavFoot() && <Naviagtion />}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default App;
